import React from 'react'
import { AsH3, HeadingMD } from '@/atoms/Text'
import { useProjectMeta } from '@/contexts/ProjectMetaContext'
import { FilmDetails as FilmDetailsType } from '@/types/codegen-contentful'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { useLocale } from '@/utils/LocaleUtil'
import { useTranslate } from '@/utils/translate/translate-client'
import { CastRail } from '@/views/WatchTheatricalView/FilmDetails/CastRail'
import { DescriptorSection } from '@/views/WatchTheatricalView/FilmDetails/DescriptorSection'
import { CrewSections, formatReleaseDate } from './FilmDetails'

interface DigitalFilmDetailsComponentProps {
  filmDetails: FilmDetailsType
}
export function DigitalFilmDetails(props: DigitalFilmDetailsComponentProps) {
  const { t } = useTranslate('theatrical-presales')
  const { locale } = useLocale()
  const projectMeta = useProjectMeta()
  const title = projectMeta.title

  const moviePosterPath = title?.portraitBackdrop?.cloudinaryPath
  const releaseDate = formatReleaseDate(locale, props.filmDetails)

  return (
    <div className="grid-col-1 grid gap-8 text-left lg:grid-cols-8 lg:gap-16">
      {moviePosterPath && (
        <div className="hidden lg:col-span-3 lg:block">
          <img
            src={getCloudinaryImageUrl({ path: moviePosterPath, width: 638, height: 930 })}
            className="ml-auto"
            alt={t('moviePosterAlt', '{{name}} Movie Poster', { name: projectMeta.name })}
            height={930}
            width={638}
          />
        </div>
      )}
      <div key="details" className="py-12 lg:col-span-5 lg:py-0">
        <div className="hidden lg:block">
          <HeadingMD weight="bold" color="white" as={AsH3} className="lg:photon-heading-lg mb-4">
            {projectMeta.name}
          </HeadingMD>
        </div>
        <div className="flex flex-col lg:flex-col-reverse">
          <div className="mb-6 w-full max-w-[95vw]">
            <CastRail />
          </div>
          <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-2">
            {title && releaseDate && (
              <DescriptorSection title={t('releaseDate', 'Release Date')} description={releaseDate} />
            )}
            <CrewSections crew={title?.crew} />
          </div>
        </div>
      </div>
    </div>
  )
}
